/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { searchGet$Json } from '../fn/search/search-get-json';
import { SearchGet$Json$Params } from '../fn/search/search-get-json';
import { searchGet$Plain } from '../fn/search/search-get-plain';
import { SearchGet$Plain$Params } from '../fn/search/search-get-plain';
import { SearchResultDto } from '../models/search-result-dto';

@Injectable({ providedIn: 'root' })
export class SearchApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchGet()` */
  static readonly SearchGetPath = '/search';

  /**
   * Global search.
   *
   * Searches queries, dashboards and other entities in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGet$Plain$Response(params?: SearchGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchResultDto>>> {
    const obs = searchGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Global search.
   *
   * Searches queries, dashboards and other entities in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGet$Plain(params?: SearchGet$Plain$Params, context?: HttpContext): Observable<Array<SearchResultDto>> {
    const resp = this.searchGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SearchResultDto>>): Array<SearchResultDto> => r.body)
    );
  }

  /**
   * Global search.
   *
   * Searches queries, dashboards and other entities in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGet$Json$Response(params?: SearchGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchResultDto>>> {
    const obs = searchGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Global search.
   *
   * Searches queries, dashboards and other entities in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGet$Json(params?: SearchGet$Json$Params, context?: HttpContext): Observable<Array<SearchResultDto>> {
    const resp = this.searchGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SearchResultDto>>): Array<SearchResultDto> => r.body)
    );
  }

}
